import { isBefore, subHours } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { cloneDeep, range, sortBy } from 'lodash-es'

import { getDateFromAppointment } from '@lyrahealth-inc/shared-app-logic/src/features/appointments/getDateFromAppointment'
import type { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import type { Curriculum } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

type AppointmentDateTime = Pick<Appointment, 'startDate' | 'startTime' | 'timeZone'>

const FUTURE_SESSION_PLANNING_WINDOW = 5

export const getFutureSessions = (
  curriculum: Curriculum[],
  currentSessionCount: number,
  canPlanFutureAssignments = false,
): number[] => {
  const curriculumSessions = curriculum.map(({ session }) => session).filter((session) => session > currentSessionCount)
  if (!canPlanFutureAssignments) return curriculumSessions
  const lastSession = Math.max(currentSessionCount + FUTURE_SESSION_PLANNING_WINDOW, ...curriculumSessions)
  return range(currentSessionCount + 1, lastSession + 1)
}

export const withCurriculumSession = (curriculum: Curriculum[], session: number): Curriculum[] =>
  curriculum.some((entry) => entry.session === session)
    ? cloneDeep(curriculum)
    : sortBy([...cloneDeep(curriculum), { name: '', session, contents: [] }], 'session')

export const getAssignmentAppointmentTiming = (appointment: AppointmentDateTime, now = new Date()) => {
  const appointmentStart = getDateFromAppointment(appointment)

  return {
    shouldConfirmSameSession: isBefore(subHours(appointmentStart, 24), now),
    formattedStart: formatInTimeZone(appointmentStart, appointment.timeZone, 'EEE, MMM d h:mm a'),
  }
}
